/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Description/view.blocks to change it.
import * as fromData from 'Simple/Data'
import React from 'react'
import TysiaTextarea from 'DesignSystem/TysiaTextarea/index'
import TysiaTextareaContent from 'DesignSystem/TysiaTextarea/TysiaTextareaContent/index'
import TysiaTextareaField from 'DesignSystem/TysiaTextarea/TysiaTextareaField/index'
import TysiaTextareaLabel from 'DesignSystem/TysiaTextarea/TysiaTextareaLabel/index'



/** @type {import('Simple/types.js').View} */
export default function Description({
  children,
  viewPath = "/DesignSystem/DataVaxiomOtherProfessionalsEdit/Content/Phone/NewPhone/Content/Fields/Description",
  onChange
  
}) {
let newPhoneDescriptionValueData = fromData.useDataValue({ viewPath,
context: 'new_phone',
path: 'description',
})
let newPhoneDescriptionChangeData = fromData.useDataChange({ viewPath,
context: 'new_phone',
path: 'description',
})
  return (<React.Fragment
>
<TysiaTextarea
  viewPath={`${viewPath}/TysiaTextarea`}
 data="new_phone.description"
 value={newPhoneDescriptionValueData}
 onChange={newPhoneDescriptionChangeData}
>
{childProps => (
<React.Fragment>
<TysiaTextareaLabel
{...childProps}
  viewPath={`${viewPath}/TysiaTextareaLabel`}
 text="Description"
/>
<TysiaTextareaContent
{...childProps}
  viewPath={`${viewPath}/TysiaTextareaContent`}
>
{childProps => (
<TysiaTextareaField
{...childProps}
  viewPath={`${viewPath}/TysiaTextareaField`}
/>
)}
</TysiaTextareaContent>
</React.Fragment>
)}
</TysiaTextarea>
{children}
</React.Fragment>)
}